<mat-card>
  <a mat-raised-button [href]="url">Click to continue</a>
</mat-card>
